import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Survey from "./Survey";
import Scheduler from "./Scheduler";
import BookingConfirmation from "./BookingConfirmation";
import ErrorType1 from "./ErrorType1";
import RescheduleCancel from "./RescheduleCancel";
import CancellationConfirmation from "./CancellationConfirmation";
import SetConfirmationMessage from "./SetConfirmationMessage";
import SetAvailability from "./SetAvailability";
import SetEmailMessage from "./SetEmailMessage"
import SetTextMessage from "./SetTextMessage"
import "./App.css"; 

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:referralCode?" element={<Survey />} />
        <Route path="/scheduler" element={<Scheduler />} /> {/* Scheduler page */}
        <Route path="/confirmation" element={<BookingConfirmation />} /> {/* Booking confirmation page */}
        <Route path="/error-type-1" element={<ErrorType1 />} /> {/* Error type 1 page */}
        <Route path="/manage/:apptId" element={<RescheduleCancel />} /> {/* Reschedule/Cancel page */}"
        <Route path="/cancellation-confirmation" element={<CancellationConfirmation />} /> {/* Cancellation confirmation page */}
        <Route path="/set-confirmation-message" element={<SetConfirmationMessage />} /> {/* Set Confirmation Message page */}
        <Route path="/set-availability" element={<SetAvailability />} /> {/* Set Availability page */}
        <Route path="/set-email-message" element={<SetEmailMessage />} /> {/* Set Confirmation Message page */}
        <Route path="/set-text-message" element={<SetTextMessage />} /> {/* Set Confirmation Message page */}
      </Routes>
    </Router>
  );
}

export default App;
